import { useAPIGetUserPermissionsSuspense } from '../../api/apiHooks/useUserPermissions'
import { useCurrentContract } from '../useCurrentContract/useCurrentContract'
import { UserPermissionsRow } from '../../../common/validations'

const DEFAULT_PERMISSIONS: UserPermissionsRow = {
  contractUuid: undefined,
  tenantRoles: [],
}

export const usePermissions = () => {
  const { currentContractId } = useCurrentContract()

  const { data } = useAPIGetUserPermissionsSuspense()

  const permissions: UserPermissionsRow =
    data.contracts.find((p) => p.contractUuid === currentContractId) ??
    DEFAULT_PERMISSIONS

  return {
    permissions,
    authLevel: data.authLevel,
    identificationRequired: data.identificationRequired,
  }
}
